import markAddressArchivedGQL from "../../../../graphQl/mutations/markAddressArchived";

export const markAddressArchived = async ({ dispatch, commit, rootGetters }, payload) => {
  const organizationId = rootGetters['app/getSelectedOrganization'].id;

  let response;

  try {
    response = await dispatch('app/request', {
      type: 'mutation',
      gql: markAddressArchivedGQL,
      variables: {
        organizationId,
        ...payload,
      },
    }, {root: true});
  } catch (error) {
    return error;
  }

  return response
};